<div class='row'>
  @if (placeOfFillingDeclarationInfo()) {
    <div class="col-12">
      <app-label label="Miejsce składania deklaracji:">
        Miejsce składania deklaracji
      </app-label>
    </div>
  }
  <div class='col-md-5'>
    <app-label label='Wniosek składany do:'>{{ applicationSubmittedTo }}</app-label>
  </div>
  @if (application()?.applicationSubject; as applicationSubject) {
    <div class='col-md-6'>
      <app-label [label]='application() | applicationSubjectLabel'>
        {{ applicationSubject }}
      </app-label>
    </div>
  }
  @if (showLocalisationUnrelatedDeviceData()) {
    <div class="col-md-4">
      <app-label label="Rodzaj urządzenia">
        {{ application()?.deviceType || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.documentReceiptMethod?.name; as documentReceiptMethod) {
    <div class='col-md-5'>
      <app-label label='Sposób odbioru:'>
        {{ documentReceiptMethod }}
      </app-label>
    </div>
  }
  @if (application()?.actType; as actType) {
    <div class="col-12">
      <app-label label="Rodzaj aktu planowania przestrzennego:">
        {{ actType }}
      </app-label>
    </div>
  }
  @if (application()?.applicationConcernsStreet; as applicationConcernsStreet) {
    <div class="col-md-4">
      <app-label label="Wniosek dotyczy ulicy:">
        {{ applicationConcernsStreet }}
      </app-label>
    </div>
  }
  @if (application()?.ePuapAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-puap:'>
        {{ application()?.ePuapAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.eDeliveryAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-doręczeń:'>
        {{ application()?.eDeliveryAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.issuedDocumentType; as issuedDocumentType) {
    <div class="col-md-4">
      <app-label label="Typ wydawanego dokumentu:">
        {{ issuedDocumentType }}
      </app-label>
    </div>
  }
  @if (application()?.documentIssuePurpose; as documentIssuePurpose) {
    <div class="col-md-6">
      <app-label [label]="(application() | documentIssuePurposeLabel) + ':'">
        {{ documentIssuePurpose }}
      </app-label>
    </div>
  }
  @if (showLocalisationUnrelatedDeviceData()) {
    @if (application()?.deviceTypeDescription; as deviceTypeDescription) {
      <div class="col-12">
        <app-label label="Opis rodzaju urządzenia:">
          {{ deviceTypeDescription }}
        </app-label>
      </div>
    }
    @if (application()?.networkOrConnectionTypeDescription; as networkOrConnectionTypeDescription) {
      <div class="col-12">
        <app-label label="Opis rodzaju sieci lub przyłącza:">
          {{ networkOrConnectionTypeDescription }}
        </app-label>
      </div>
    }
  }
  @if (application()?.notes; as notes) {
    <div class="col-12">
      <app-label label="Uwagi:">
        {{ notes }}
      </app-label>
    </div>
  }
  @if (application()?.legalInterest; as interest) {
    <div class="col-12">
      <app-label label="Interes prawny:">
        {{ interest }}
      </app-label>
    </div>
  }
</div>
@if (showResponsiblePerson()) {
  <br>
  <p class="mb-2">Osoba odpowiedzialna</p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.responsiblePersonFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.responsiblePersonLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.responsiblePersonPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.responsiblePersonEmail || '-' }}
      </app-label>
    </div>
  </div>
}
@if (showManager()) {
  <br>
  <p class="mb-2">Kierownik robót</p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.managerFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.managerLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.managerPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.managerEmail || '-' }}
      </app-label>
    </div>
  </div>
}
@if (showLocationUnrelatedDeviceData()) {
  <br>
  <p class="mb-2"><strong>Rodzaj urządzenia</strong></p>
  <div class="row">
    <div class="col-md-6">
      <app-label label="Rodzaj:">
        {{ application()?.deviceType || '-' }}
      </app-label>
    </div>
  </div>
  <br>
  <p class="mb-2"><strong>Rodzaj elementu pasa drogowego</strong></p>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Szerokość jezdni:">
        {{ application()?.roadwayWidth | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Długość jezdni:">
        {{ application()?.roadwayLength | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powierzchnia jezdni:">
        {{ application()?.roadwayArea | number }} (m<sup>2</sup>)
      </app-label>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Szerokość chodników, zatok postojowych, <br> ścieżek rowerowych:">
        {{ application()?.sidewalkWidth | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Długość chodników, zatok postojowych, <br> ścieżek rowerowych:">
        {{ application()?.sidewalkLength | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powierzchnia chodników, zatok postojowych, <br> ścieżek rowerowych:">
        {{ application()?.sidewalkArea | number }} (m<sup>2</sup>)
      </app-label>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Szerokość pozostałych elementów pasa drogowego (pobocza, rowu, <br>  pasa zieleni):">
        {{ application()?.remainingElementsWidth | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Długość pozostałych elementów pasa drogowego (pobocza, rowu, <br> pasa zieleni):">
        {{ application()?.remainingElementsLength | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powierzchnia pozostałych elementów pasa drogowego (pobocza, rowu, <br> pasa zieleni):">
        {{ application()?.remainingElementsArea | number }} (m<sup>2</sup>)
      </app-label>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Szerokość zajęcia na <br> obiekcie mostowym:">
        {{ application()?.bridgeStructureWidth | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Długość zajęcia na <br> obiekcie mostowym:">
        {{ application()?.bridgeStructureLength | number }} (m)
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powierzchnia zajęcia na <br> obiekcie mostowym:">
        {{ application()?.bridgeStructureArea | number }} (m<sup>2</sup>)
      </app-label>
    </div>
  </div>
  <br>
  <p class="md-2"><strong>Termin umieszczenia</strong></p>
  <div class="row">
    <div class="col-md-3">
      <app-label label="Od dnia:">
        {{ application()?.placementDate | date }}
      </app-label>
    </div>
  </div>
}
@if (showCorrespondenceAddress()) {
  <br>
  <p class="mb-2"><strong>Adres korespondencyjny</strong></p>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Kraj:">
        {{ application()?.correspondenceCountry || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Województwo:">
        {{ application()?.correspondenceVoivodeship || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Powiat:">
        {{ application()?.correspondenceCounty || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Gmina:">
        {{ application()?.correspondenceMunicipality || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Miejscowość:'>
        {{ application()?.correspondenceCity || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Ulica:'>
        {{ application()?.correspondenceStreet || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr domu:'>
        {{ application()?.correspondenceHouseNumber || '-' }}
      </app-label>
      @if (application()?.correspondenceApartmentNumber; as apartmentNumber) {
        &nbsp;
        <app-label label='Nr mieszkania:'>
          {{ apartmentNumber || '-' }}
        </app-label>
      }
    </div>
    <div class='col-md-4'>
      <app-label label='Poczta:'>
        {{ application()?.correspondencePostOffice || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Kod pocztowy:'>
        {{ application()?.correspondencePostalCode || '-' }}
      </app-label>
    </div>
  </div>
}
